import React from 'react'
import { useHistory } from 'react-router-dom'
import { useAnalytics } from 'reactfire'

import {
  Title,
  Paragraph,
  Button,
  Wrap,
  ColumnWrap,
} from 'src/components/Modal/styled'
import { Modal } from 'src/components/Modal'
import { QUIZZES } from 'src/constants/routes'
import { analyticsEvents } from 'src/constants/analytics/events'

interface LeaveModalProps {
  isOpen: boolean
  onClose: () => void
}

const LeaveModal: React.FC<LeaveModalProps> = ({ isOpen, onClose }) => {
  const { push } = useHistory()
  const { logEvent } = useAnalytics()

  const handleLeaveClick = () => {
    logEvent(analyticsEvents.quizCanceled)
    push(QUIZZES)
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Wrap>
        <Title>Are you sure you want to leave?</Title>
        <Paragraph>Your progress will not be saved.</Paragraph>
        <ColumnWrap>
          <Button onClick={handleLeaveClick} red>
            Leave
          </Button>
          <Button onClick={onClose} secondary>
            Cancel
          </Button>
        </ColumnWrap>
      </Wrap>
    </Modal>
  )
}

export default LeaveModal
